import { GenericCollectionFactory } from "../../_generics";
import { GENERIC_IDS } from "../../_constants/generics.constants";

export const AuthorizationStore = GenericCollectionFactory(
    GENERIC_IDS.AUTHORIZATIONS,
    "uid",
);
